import { useEffect } from 'react';

import { Flex } from '@raystack/apsara';

import { useCopilotSelector } from '@src/contexts';
import { Show } from '@src/hoc';
import { useCopilot } from '@src/hooks/useCopilot';
import { stringifyJson } from '@src/utils';
import { PromptsProps } from '@src/utils/types/CopilotTypes';

import { MessagesSkeleton } from './Loaders';
import { WelcomeScreen } from './WelcomeScreen';

import styles from './MultiChat.module.css';

export const ChatScreen = ({ handleSelectPrompt }: PromptsProps) => {
  const chatId = useCopilotSelector(state => state.chatId);
  const chatData = useCopilotSelector(state => state.chatData);
  const messages = useCopilotSelector(state => state.messages);
  const initializingCopilot = useCopilotSelector(
    state => state.initializingCopilot
  );

  const stepDataStr = stringifyJson(chatData?.steps || []);
  const { setMessages, fetchMessages } = useCopilot();

  useEffect(() => {
    fetchMessages(chatId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatId]);

  useEffect(() => {
    setMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stepDataStr]);

  return (
    <Show when={!initializingCopilot} fallback={<MessagesSkeleton />}>
      <Show
        when={stepDataStr?.length > 0}
        fallback={<WelcomeScreen handleSelectPrompt={handleSelectPrompt} />}
      >
        <Flex direction='column' className={styles.chatList} gap={9}>
          {messages}
        </Flex>
      </Show>
    </Show>
  );
};
